/* Pastillas con movimiento 144 · Peak | E-Commerce Lab · v1.0
   Uso: contenedor [data-pfx] con pastillas [role="tab"].
   data-pfx-d / data-pfx-m: none | wave | pulse | shake | glow | shine
   data-pfx-target: all | inactive · data-pfx-dur / data-pfx-pause en ms · data-pfx-front: true = la seleccionada pasa al inicio. */
(function () {
  if (window.__pfx144) return;
  window.__pfx144 = true;
  var mq = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function visible(el) {
    var r = el.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
    if (!r.width && !r.height) return false;
    return Math.min(r.bottom, vh) - Math.max(r.top, 0) > Math.min(r.height, vh) * 0.35;
  }

  function init(box) {
    if (!box || box.dataset.pfxReady) return;
    box.dataset.pfxReady = '1';
    var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var dur = parseInt(box.dataset.pfxDur, 10) || 900;
    var pause = parseInt(box.dataset.pfxPause, 10); if (isNaN(pause)) pause = 4000;
    var timer = null, hovering = false, stopped = false, seen = false;

    function mode() { return reduce.matches ? 'none' : ((mq.matches ? box.dataset.pfxM : box.dataset.pfxD) || 'none'); }
    function clear() { clearTimeout(timer); timer = null; tabs.forEach(function (t) { t.classList.remove('pfx-go'); }); }
    function cycle() {
      clear();
      var m = mode(); box.dataset.pfxNow = m;
      if (m === 'none' || hovering || stopped || !seen) return;
      var list = tabs.filter(function (t) { return box.dataset.pfxTarget === 'all' || t.getAttribute('aria-selected') !== 'true'; });
      var stagger = Math.max(120, Math.round(dur * 0.45));
      list.forEach(function (t, i) {
        setTimeout(function () {
          if (hovering || stopped) return;
          t.classList.remove('pfx-go'); void t.offsetWidth; t.classList.add('pfx-go');
          setTimeout(function () { t.classList.remove('pfx-go'); }, dur + 60);
        }, i * stagger);
      });
      timer = setTimeout(cycle, list.length * stagger + dur + pause);
    }
    function check() {
      var v = visible(box);
      if (v && !seen) { seen = true; timer = setTimeout(cycle, 400); }
      else if (!v && seen) { seen = false; clear(); }
    }
    box.addEventListener('mouseenter', function () { hovering = true; clear(); });
    box.addEventListener('mouseleave', function () { hovering = false; if (seen && !stopped) timer = setTimeout(cycle, 400); });
    box._pfxCheck = check;
    box.dataset.pfxNow = mode();
    check();

    /* La seleccionada pasa al inicio */
    function front(animate) {
      var on = box.dataset.pfxFront === 'true';
      var before = animate && !reduce.matches ? tabs.map(function (t) { return t.getBoundingClientRect(); }) : null;
      tabs.forEach(function (t) { t.style.order = on && t.getAttribute('aria-selected') === 'true' ? '-1' : ''; });
      if (before && on && tabs[0].animate) {
        tabs.forEach(function (t, i) {
          var a = before[i], b = t.getBoundingClientRect(), dx = a.left - b.left, dy = a.top - b.top;
          if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
          t.animate([{ translate: dx + 'px ' + dy + 'px' }, { translate: '0px 0px' }], { duration: 420, easing: 'cubic-bezier(.3,.7,.2,1)' });
        });
      }
      if (on && box.scrollWidth > box.clientWidth + 2) box.scrollTo({ left: 0, behavior: animate && !reduce.matches ? 'smooth' : 'auto' });
    }
    var busy = false;
    new MutationObserver(function () {
      if (busy) return; busy = true;
      setTimeout(function () { busy = false; front(true); }, 20);
    }).observe(box, { attributes: true, subtree: true, attributeFilter: ['aria-selected'] });
    tabs.forEach(function (t) { t.addEventListener('click', function () { if (box.dataset.pfxStop === 'true') { stopped = true; clear(); } }); });
    front(false);
  }

  function initAll(scope) { (scope || document).querySelectorAll('[data-pfx]').forEach(init); }
  var st;
  window.addEventListener('scroll', function () {
    if (st) return;
    st = setTimeout(function () { st = null; document.querySelectorAll('[data-pfx]').forEach(function (b) { if (b._pfxCheck) b._pfxCheck(); }); }, 150);
  }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
